import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AppConstant } from '../../../../../../Assests/AppConstant';
import { sagaActions } from '../../../../../../../sagas/sagaActions';
import { getTruckSelector } from '../../../../../../../redux/reducers/reducerSlices/getTruckReducer';
import {  getRemoteConfigSelector } from '../../../../../../../redux/reducers/reducerSlices/RemoteConfigReducer';
import {  getDefaultDashboardSelector } from '../../../../../../../redux/reducers/reducerSlices/DefaultDashboardReducer';
import Loader from '../../../../../Loader/Loader.jsx';
import { dateAndTimeUTCFormat, isCheckedInMoreThan15Min, modifyPODisplay } from '../../../../../../Assests/Utility';
import { ReactComponent as Pending } from '../../../../../../Assests/Svg/Pending.svg';
import { ReactComponent as PendingApproval } from '../../../../../../Assests/Svg/PendingApproval.svg';
import { ReactComponent as NoDataLightMode } from '../../../../../../Assests/Svg/NoDataLightMode.svg';
import { ReactComponent as NoDataDarkMode } from '../../../../../../Assests/Svg/NoDataDarkMode.svg';
import { ReactComponent as AwatingDriverConfirmIcon } from '../../../../../../Assests/Svg/await-driver-confirm-icon.svg';
import { ReactComponent as DoorAssignedIcon } from '../../../../../../Assests/Svg/door-assigned-icon.svg';
import { ReactComponent as PendingApprovalStatusIcon } from '../../../../../../Assests/Svg/pending-approval-status-icon.svg';
import { ReactComponent as PoApprovedIcon } from '../../../../../../Assests/Svg/po-approved-icon.svg';
import { ReactComponent as StagingIcon } from '../../../../../../Assests/Svg/staging-icon.svg';
import { ReactComponent as UnloadingIcon } from '../../../../../../Assests/Svg/unloading-icon.svg';
import { ReactComponent as DriverUnload } from '../../../../../../Assests/Svg/DriverUnload.svg';

import './TruckList.css';
import { getLoadSelector } from '../../../../../../../redux/reducers/reducerSlices/getLoadReducer';
import { usePrevious } from '../../../../../Common/CustomHooks/usePrevious';
import _ from 'lodash';
import CustomTooltip from '../../../../../Common/Tooltip/CustomTooltip';
import { getDockFilterListSelector, getIsSearchingStatusSelector, getPOListFilterSelector, getSelectedDockFilterListSelector, getSelectedFiltersSelector, getSelectedStatusFilterListSelector, getStatusFilterListSelector } from '../../../../../../../redux/reducers/reducerSlices/FiltersReducerSlice.jsx';
import { applyFilters, createStatusFilterList } from '../../../POFilters/FilterUtilities.jsx';
import { getUserSelector } from '../../../../../../../redux/reducers/reducerSlices/UserReducer.js';

const TruckList = (props) => {

    const dispatch = useDispatch();
    const { themeSelected, viewChangeHandler, useCarrier } = props;
    const getTruck = useSelector(getTruckSelector);
    const getLoad = useSelector(getLoadSelector);
    const { selectedLoad } = getLoad;
    const { truckList, getListLoading, truckListMasterData, scheduledList, unscheduledList, isSubscriptionUpdate, subscriptionTruckData } = getTruck;
    const loaderArray = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    const [intervalHandler, setIntervalHandler] = useState(null);
    const remoteConfig = useSelector(getRemoteConfigSelector);
    const { autoFetchExecutorInterval } = remoteConfig;
    const previousPoListInterval = usePrevious(intervalHandler);
    const dashboard = useSelector(getDefaultDashboardSelector)
    const { dateRangeObj, isWorkDay } = dashboard
    const previousDateInterval = usePrevious(dateRangeObj);
    const selectedFiltersList = useSelector(getSelectedFiltersSelector);
    const isSearching = useSelector(getIsSearchingStatusSelector);
    const poListFilter = useSelector(getPOListFilterSelector);
    const userPermission = useSelector(getUserSelector);
    const { selectedWarehouse } = userPermission;
    const selectedLoadRef = useRef();
    
     //Added for ALDI-1.0
    useEffect(() => {
        if(!isSearching){
            // dispatch({ type: sagaActions.AUTO_FETCH_PO_LIST, payload: true });
            updateTruckList([...selectedFiltersList]);
        }
    }, [selectedFiltersList, truckListMasterData])

    useEffect(() => {
        if (selectedLoad) {
            selectedLoadRef.current = selectedLoad
        } else {
            selectedLoadRef.current = null
        }
    },[selectedLoad])

   const truckTemp = useMemo(() => {
    let selectedList = [];

    if (poListFilter === 'Scheduled') {
        selectedList = scheduledList;
    } else if (poListFilter === 'Unscheduled') {
        selectedList = unscheduledList;
    } else {
        selectedList = truckList;
    }

    return selectedList.filter(Boolean); // removes undefined, null, false, 0, ""
}, [poListFilter, scheduledList, unscheduledList, truckList]);


    useEffect(() => {
        if (!isSubscriptionUpdate) {
            dispatch({ type: sagaActions.RESET_LOAD_TRUCK_DETAILS });
        }
        setTimeout(() => {
            loadDetailsSelectFirst();
        }, 500);
    },[truckTemp])

    const loadDetailsSelectFirst = () => {
        if (_.isEmpty(selectedLoadRef?.current)) {
            let selectedLoadTemp = {}
            selectedLoadTemp = { ...selectedLoadTemp, ...truckTemp[0] }
            dispatch({ type: sagaActions.INTIATE_TRUCK_DETAILS })
            dispatch({ type: sagaActions.LOAD_TRUCK_DETAILS, payload: selectedLoadTemp })
            if (selectedLoadTemp?.dock_id) {
                dispatch({ type: sagaActions.GET_DOOR, payload: { dock_id: selectedLoadTemp.dock_id } })
            }
        } else if (!_.isEmpty(selectedLoadRef?.current)) {
            if (isSubscriptionUpdate) {
                if (subscriptionTruckData?.data?.load_control_num === selectedLoadRef?.current?.load_control_num) {
                    // If it was, find the latest data for that load.
                    const updatedSelectedLoad = truckList.find(el => el.load_control_num === selectedLoadRef?.current?.load_control_num);
    
                    // And dispatch the update.
                    if (updatedSelectedLoad) {
                        dispatch({ type: sagaActions.LOAD_TRUCK_DETAILS, payload: updatedSelectedLoad });
                    } else {
                         dispatch({ type: sagaActions.RESET_LOAD_TRUCK_DETAILS });
                    }
                    dispatch({ type: sagaActions.RESET_SUBSCRIPTION_UPDATE_FLAG, payload: false });
                    dispatch({ type: sagaActions.SET_TRUCK_DATA_FROM_SUBSCRIPTION, payload: {} })
                } else {
                    dispatch({ type: sagaActions.RESET_SUBSCRIPTION_UPDATE_FLAG, payload: false });
                    return;
                }
            } else {
                const getLatestUpdatesSelectedLoad = truckList.filter(el => el.load_control_num === selectedLoadRef?.current.load_control_num)
                dispatch({ type: sagaActions.LOAD_TRUCK_DETAILS, payload: getLatestUpdatesSelectedLoad.length ? getLatestUpdatesSelectedLoad[0] : selectedLoadRef?.current });
                dispatch({ type: sagaActions.RESET_SUBSCRIPTION_UPDATE_FLAG, payload: false });
            }
        }
    }

    // useEffect(() => {
    //     /* Auto Fetch PO-List - when Auto Fetch Happens*/
    //     // dispatch({ type: sagaActions.SET_DOCK_FILTERS_LIST, payload: [] });
    //     // dispatch({ type: sagaActions.SET_STATUS_FILTERS_LIST, payload: [] });
    //     if(!isSearching){
    //         // dispatch({ type: sagaActions.AUTO_FETCH_PO_LIST, payload: true });
    //         updateTruckList([...selectedFiltersList]);
    //     }
        
    // }, [truckListMasterData, selectedFiltersList, poListFilter])

    const updateTruckList = (filtersArr) => {
        let filterList = applyFilters(filtersArr, truckListMasterData);
        filterList = filterList.length ? filterList: truckListMasterData
        
        if (filtersArr.length === 0 && filterList.length === 0) {
            dispatch({ type: sagaActions.UPDATE_TRUCK, payload: truckListMasterData });
        } else {
            dispatch({ type: sagaActions.UPDATE_TRUCK, payload: filterList });
        }
        // updateStatusFiltersCount();

    }


    useEffect(() => {
        /* Auto Fetch PO-List after every 35 seconds */
        // if (intervalHandler) {
        //     setIntervalHandler(clearInterval(intervalHandler))
        // }
        // const settingInterval = setInterval(() => {
        //     /* To Resolve - http://10.10.0.10:8880/browse/WP-337
        //     More Door - Change Door consistently freezes screen after toggling between legend categories
        //     */
        //     const changeDoorPopupDOM = document.querySelector('#changeDoorPopup');
        //     if (changeDoorPopupDOM && !changeDoorPopupDOM.className.includes('show')) {
        //         if (intervalHandler !== previousPoListInterval) {
        //             fetchTruckList(false);
        //         }
        //     }
        // }, autoFetchExecutorInterval);
        // setIntervalHandler(settingInterval)

        const changeDoorPopupDOM = document.querySelector('#changeDoorPopup');
        if (changeDoorPopupDOM && !changeDoorPopupDOM.className.includes('show')) {
            if (intervalHandler !== previousPoListInterval) {
                fetchTruckList(false);
            }
        }
        return () => {
            dispatch({ type: sagaActions.CLEAR_FILTERS });
            dispatch({ type: sagaActions.RESET_TRUCK_DATA })
            dispatch({ type: sagaActions.SET_TASK_ITEM, payload: null });
            dispatch({type: sagaActions.TASK_ITEM_DUE_SELECTED_DOCK_LIST, payload: []})
        }
    }, [])

    useEffect(() => {
        if (useCarrier) {
            renderTruck()
        }
    }, [useCarrier])

    useEffect(() => {
        if(dateRangeObj && dateRangeObj.start){
            if(previousDateInterval && previousDateInterval.start && previousDateInterval.start !== dateRangeObj.start){
                fetchTruckList(true);
            }
        }
        
    }, [dateRangeObj])
    
    useEffect(() => {
        fetchTruckList(true);
    },[isWorkDay])

    const fetchTruckList = (showLoader) => {

        showLoader && dispatch({ type: sagaActions.INTAITE_GET_TRUCK })
        // dispatch({ type: sagaActions.AUTO_FETCH_PO_LIST, payload: true });
        dispatch({ type: sagaActions.FETCH_TRUCK_LIST, payload: '' })
    }

    const changeHandler = e => {
        const id = e.target.closest('tr').id;
        if (id) {
            const updatedTruckList = truckList.map(el => {
                if (el.load_control_num === id) {
                    let newEl = { ...el }
                    newEl.checked = !newEl.checked
                    return newEl
                }
                else {
                    return el;
                }
            })
            dispatch({ type: sagaActions.UPDATE_TRUCK, payload: updatedTruckList })
        }
    }

    const selectionHandler = (e) => {
        const { id } = e.currentTarget;
        if (id !== selectedLoad.load_control_num) {
            let filterSelectedLoad = truckList.filter(el => el.load_control_num === id)
            if (filterSelectedLoad.length) {
                dispatch({ type: sagaActions.INTIATE_TRUCK_DETAILS });
                dispatch({ type: sagaActions.LOAD_TRUCK_DETAILS, payload: filterSelectedLoad[0] });
                if (filterSelectedLoad[0]?.dock_id) { 
                    dispatch({ type: sagaActions.GET_DOOR, payload: {dock_id: filterSelectedLoad[0].dock_id}})
                }
                if (props.hasOwnProperty('viewChangeHandler')) viewChangeHandler()
            }
        }
    }



    const emptyList = () => {
        return (
            <tr className='text-center align-middle' data-testid={AppConstant.dataTestId.emptyList}>
                <td colSpan={8} className='no-data-wrappper'>
                    <div className='d-flex flex-column align-items-center'>
                        <span className='no-data-svg'>{themeSelected === 'light-mode' ? <NoDataLightMode /> : <NoDataDarkMode />}</span>
                        <span className={`no-data-text1 ${themeSelected}`}>{AppConstant.poManagement.emptyTable.text1}</span>
                        <span className={`no-data-text2 ${themeSelected}`}>{AppConstant.poManagement.emptyTable.text2}</span>
                    </div>
                </td>
            </tr>
        )
    }

    const applyDoorcss = (el,i) => {
        let returncss = `col-md-auto ${themeSelected}`  
        if(!el.door_acknowledege && parseInt(el.door)){
            returncss = `${returncss} isNotDoorAcknowledge` 
        }  
        return returncss;
    }

    const renderTruck = () => {

        return truckTemp && truckTemp.length ? truckTemp.map((el,i) => {
            let morePoList = modifyPODisplay(el?.po);
            let seqNumber = el?.truckSequence  || '-'
            // const iconStatusHandler = (el) => {
            //     if(el.driver_unload){
            //         return <DriverUnload />
            //     }
            //     switch (el.po_status) {
            //         case AppConstant.poManagement.statusFilters.pending:
            //             return <PendingApproval />
            //         case AppConstant.poManagement.statusFilters.approved:
            //             return <PoApprovedIcon />
            //         case AppConstant.poManagement.statusFilters.staging:
            //             return <StagingIcon />
            //         case AppConstant.poManagement.statusFilters.unloading:
            //             return <UnloadingIcon />
            //         case AppConstant.poManagement.statusFilters.pendingApproval:
            //             return <PendingApprovalStatusIcon />
            //         case AppConstant.poManagement.statusFilters.awatingDriver:
            //             return <AwatingDriverConfirmIcon />
            //         case AppConstant.poManagement.statusFilters.doorAssigned:
            //             return <DoorAssignedIcon />
            //         default:
            //             return <Pending fill='#106D96' />
            //     }
            // }

            const defaultObj = {
                date: '-',
                time: '-'
            }

            const appointment_time_formated = el.appointment_time? dateAndTimeUTCFormat(el.appointment_time): defaultObj
            const check_in_time_formated = el.check_in_time ? dateAndTimeUTCFormat((el.check_in_time)): defaultObj
            
            return (
                <tr className={`text-center align-middle ${themeSelected} ${selectedLoad.load_control_num === el.load_control_num ? 'active' : ''} ${isCheckedInMoreThan15Min(el)}`} key={el.load_control_num + "_" + i} id={el.load_control_num} onClick={selectionHandler}>
                    {/* Asked By Rajesh to comment for now */}
                    {/* <td className={`col-md-auto ${themeSelected}`}>
                        <div className="d-flex flex-row justify-content-around align-items-center po-checkbox-icon-wrapper">
                            <input type="checkbox" style={{ width: '16px', height: '16px' }} checked={el.checked} onChange={changeHandler} />
                        </div>
                    </td> */}
                    {/* <td className={`col-md-auto ${themeSelected} `}>
                        <div data-tip={`${el.po_status}`} data-for={`${el.po_status}_${el.load_control_num}`}>
                            <div className='po-icon-status'>
                                    {iconStatusHandler(el)}
                            </div>
                            <CustomTooltip
                                id={`${el.po_status}_${el.load_control_num}`} 
                                position='top'
                                type={themeSelected === AppConstant.commonStrings.lightModeFilterString ? 'light' : 'dark'}
                                multiline={false} />
                        </div>
                    </td> */}
                     {selectedWarehouse?.operationType === 'WORKDAY'  && isWorkDay ? <td className={`col-md-auto ${themeSelected} pl-2`}>
                        {seqNumber}
                    </td>: ''}
                    <td className={`col-md-auto ${themeSelected} pl-2`}>
                        {morePoList}
                    </td>
                    <td className={`col-md-auto ${themeSelected}`}>
                        <div className="d-flex flex-column">
                            <span className=''>
                                {appointment_time_formated.date}
                            </span>
                            <span className=''>
                                {appointment_time_formated.time}
                            </span>
                        </div>
                    </td>
                    <td className={`col-md-auto bg-transparent ${themeSelected}`}>{useCarrier === 'carrier' ? el.carrier || '-' :  el.vendor || '-'}</td>
                    <td className={`col-md-auto ${themeSelected}`}>
                        <div className="d-flex flex-column">
                            <span className=''>
                                {check_in_time_formated.date}
                            </span>
                            <span className=''>
                                {check_in_time_formated.time}
                            </span>
                        </div>
                    </td>
                    <td className={`col-md-auto ${themeSelected}`}>{el.dock || '-'}</td>
                    <td className={applyDoorcss(el, i)}>{el.door || '-'}</td>
                    <td className={`col-md-auto ${themeSelected}`}>{el?.truck_load_status || '-'}</td>
                </tr>
            )
        }) : emptyList()

    }

    return (
        <tbody className='tableBody'>
            {
                !getListLoading ?
                    <>
                        {renderTruck()}
                    </>
                    :

                    loaderArray.map((_, i) => {
                        return (
                            <tr key={i} data-testid={AppConstant.dataTestId.tableLoaders + '_' + i}>

                                {
                                    (selectedWarehouse?.operationType === 'WORKDAY' && isWorkDay
                                        ? [1, 2, 3, 4, 5, 6, 7, 8]
                                        : [1, 2, 3, 4, 5, 6, 7]
                                      ).map((__, j) => {
                                        return (
                                            <td key={j}>
                                                <Loader height={35} count={1} highlightColor={themeSelected === 'dark-mode' ? '#151515' : ''}
                                                    baseColor={themeSelected === 'dark-mode' ? '#575757'
                                                        : ''}
                                                />
                                            </td>
                                        )

                                    })
                                }

                            </tr>
                        )
                    })
            }


        </tbody>
    )
}
export default TruckList;